/* eslint-disable react-hooks/exhaustive-deps */
import http from "core/auth-http";
import handlApiError from "core/handleApiError";
import { createContext, useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form"
import { schema } from "./form-object"
import { yupResolver } from "@hookform/resolvers/yup"
import { useDispatch } from "react-redux"
import { axiosActions } from "rtk/slices/axios-slice"
import { formatAmount } from "core/functions"

const StateContext = createContext({
  form: undefined,
  isInitLoad: true,
  apiData: {},
  onSubmit: formData => { },
})

export const ContextProvider = ({ children }) => {

  const form = useForm({
    defaultValues: {
      currency_id: 1,
      rate: 1,
    },
    resolver: yupResolver(schema)
  })

  const { watch, reset } = form
  const dispatch = useDispatch()
  const [apiData, setApiData] = useState({})
  const [isInitLoad, setIsInitLoad] = useState(true)
  const {
    setSending,
    setSuccess,
    setInitDataLoad,
    setFailure,
    setErrors,
    setShowErrowModal,
    setEditLink,
    setPrintLink,
  } = axiosActions
  const amount = watch('amount')
  const rate = watch('rate')

  useEffect(() => {
    initialData()
  }, [])

  useEffect(() => {
    calcTotal()
  }, [amount, rate])

  // calc total
  const calcTotal = () => {
    const product = amount * rate
    setApiData({
      ...apiData,
      total: formatAmount(product)
    })
  }

  const initialData = async () => {
    return http.get('/finance/cash-payment/create')
      .then(res => {
        const { ledgers, currencies } = res.data
        setApiData({
          ...apiData,
          ledgers: ledgers,
          currencies: currencies,
        })
      })
      .catch(error => {
        dispatch(setFailure(true))
        dispatch(setShowErrowModal(true))
        dispatch(setErrors(handlApiError(error)))
      })
      .finally(() => {
        dispatch(setInitDataLoad(false))
        setIsInitLoad(false)
      })
  }

  const onSubmit = async formData => {
    dispatch(setSending(true))
    http.post('/finance/cash-payment', formData)
      .then(res => {
        const { insertedId } = res.data
        dispatch(setSuccess(true))
        dispatch(setEditLink(`/finance/cash_payment/${insertedId}/edit`))
        dispatch(setPrintLink(`/finance/cash_payment/${insertedId}`))

        reset()
      })
      .catch(error => {
        dispatch(setFailure(true))
        dispatch(setShowErrowModal(true))
        dispatch(setErrors(handlApiError(error)))
      })
  }

  return (
    <StateContext.Provider value={{
      form,
      isInitLoad,
      apiData,
      onSubmit,
    }}>
      {children}
    </StateContext.Provider>
  )
}

export const useStateContext = () => useContext(StateContext)
